import addMinutes from 'date-fns/add_minutes';
import addHours from 'date-fns/add_hours';
import getHours from 'date-fns/get_hours';
import getMinutes from 'date-fns/get_minutes';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

export default {
    /**
     * Creates timeslots for a given date.
     *
     * @param {String} date
     * @returns {Object}
     */
    createForDate(date) {
        const slots = {
            morning: [],
            afternoon: [],
            evening: [],
        };

        // TODO: Determine start time
        const startTime = 8;
        const endMorning = 12;
        const endAfternoon = 18;
        const endEvening = 21;

        // Fill morning
        let result = addHours(parse(date), startTime);

        while (getHours(result) !== endMorning) {
            slots.morning.push({
                time: format(result, 'HH:mm'),
                instance: result,
            });

            result = addMinutes(result, 10);
        }

        // Fill afternoon
        while (getHours(result) !== endAfternoon) {
            slots.afternoon.push({
                time: format(result, 'HH:mm'),
                instance: result,
            });

            result = addMinutes(result, 10);
        }

        // Fill evening
        while (getHours(result) !== endEvening) {
            slots.evening.push({
                time: format(result, 'HH:mm'),
                instance: result,
            });

            result = addMinutes(result, 10);
        }

        return slots;
    },

    /**
     * Returns the first avaible daypart string for a given array of times
     * and the current slots object.
     *
     * @param {Object} slots - Current timeslots object for booking.
     * @param {Array} times - Available times returned by the GMS.
     * @returns {String}
     */
    getDaypartForFirstAvailableSlot(slots, times) {
        const mappedTimes = times.map((time) => time.startTime);

        /* eslint-disable */
        for (const index in slots) {
            const object = slots[index];
            const mapped = object.map((timeObject) => timeObject.time);
            if (_.indexOf(mapped, mappedTimes[0]) > -1) {
                return index;
            }
        }
        /* eslint-enable */

        return 'morning';
    },

    /**
     * Builds a collection of available timeslots for the next claim,
     * by using a offset. The GMS returns slots for the whole day,
     * not (yet) by offset of previous claims.
     *
     * @param {Number} index
     * @param {Array} times
     * @param {Object} flight
     * @returns {Array}
     */
    getAvailableSlotsForClaimIndex(index, times, flight) {
        if (index == 0) {
            return times;
        }

        // Get last round start time and caculate the next time with an offset.
        const date = new Date();
        // eslint-disable-next-line no-useless-escape
        const time = flight.claims[index - 1].startTime.split(/\:|\-/g);
        date.setHours(time[0]);
        date.setMinutes(time[1]);

        const offset = 2; // TODO: No magic offset ofcourse.
        const nextTime = format(addHours(date, 2), 'HH:mm');

        const nextTimeIndex = _.indexOf(times, nextTime);

        if (nextTimeIndex < 0) {
            return [];
        }

        const calculatedTimes = times.splice(nextTimeIndex);
        return calculatedTimes;
    },
};
